import { QueryParamConfig } from 'use-query-params';

export const getQueryParamDefaultValues = <
  QueryConfig extends { [key: PropertyKey]: QueryParamConfig<D, D2> },
  D = unknown,
  D2 = D
>(
  config: QueryConfig
): {
  [key in keyof QueryConfig]: QueryConfig[key]['default'];
} =>
  Object.entries(config).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value.default }),
    {} as {
      [key in keyof QueryConfig]: QueryConfig[key]['default'];
    }
  );

export default getQueryParamDefaultValues;
